import { IsString } from "class-validator";

export class Furniture {
  @IsString()
  readonly id: string;

  @IsString()
  readonly label: string;

  constructor(init?: Furniture) {
    this.id = init?.id!;
    this.label = init?.label!;
  }
}

export default Furniture;
